<!-- 属性设置 -->
<template>
    <div class="business-content-main">
        <breadcrumb></breadcrumb>
        <el-container style="height: 760px; margin-top: 10px">
            <el-container style="height: 100%">
                <el-aside :width="isShrink ? '0' : '15%'" height="100%" style="transition: all 0.3s">
                    <el-card class="box-card" style="padding: 25px; height: 100%; overflow: auto">
                        <el-tree check-strictly highlight-current default-expand-all :data="attrTypeData" ref="tree"
                            node-key="Id" :props="treeProps" :current-node-key="currentNodeKey"
                            @node-click="handleNodeClick"></el-tree>
                    </el-card>
                </el-aside>
                <div class="shrink-out-view" @click="changeShrink">
                    <div class="shrink-in-view"><i class="el-icon-arrow-right" :class="{ active: !isShrink }"></i></div>
                </div>
                <el-main :width="isShrink ? '0' : '85%'" height="100%"
                    style="padding-top: 0px; padding-bottom: 0px; transition: all 0.3s">
                    <el-card class="box-card" style="padding: 20px 50px; height: 100%">
                        <div v-if="isShowPL">
                            <div class="search-ctn">
                                <div class="search-ctn-left">
                                    <el-button size="small" icon="el-icon-plus" class="search-btn btn-primary"
                                        v-if="permission.add" @click="showLevelInfoes()">新增价格等级</el-button>
                                    <el-button size="small" icon="el-icon-setting" class="search-btn" type="primary"
                                        v-if="permission.quickSort" @click="quickSort">{{
                                            permission.quickSort
                                        }}</el-button>
                                </div>
                            </div>
                            <div class="table-ctn">
                                <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border
                                    style="width: 100%" height="680px">
                                    <el-table-column min-width="150px" prop="LevelName" label="价格等级名称"
                                        show-overflow-tooltip> </el-table-column>
                                    <el-table-column width="120px" prop="PriceType" label="价格类型" show-overflow-tooltip>
                                        <template slot-scope="scope">
                                            {{ scope.row.PriceType == 1 ? '成本价' : scope.row.PriceType == 2 ? '批发价' :
                                                scope.row.PriceType == 3 ? '销售价' : '-' }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column width="100px" prop="PricePoint" label="点数" show-overflow-tooltip>
                                        <template slot-scope="scope" slot="header">
                                            <span>
                                                点数
                                                <el-tooltip :aa="scope" class="item" effect="dark"
                                                    content="价格=点数*价格类型（例如：价格类型：批发价500，点数：1.2，则设置价格等级计算结果=500*1.2=600）" placement="top-start">
                                                    <i class='el-icon-warning-outline' style="margin-left:5px;color: orange;"> </i>
                                                </el-tooltip>
                                            </span>
                                        </template>
                                        <template slot-scope="scope">
                                            {{ scope.row.PriceType == 0 ? '-' : scope.row.PricePoint }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column min-width="100px" prop="LevelNum" label="级别数序"
                                        show-overflow-tooltip></el-table-column>
                                    <el-table-column width="150px" prop="CalcType" label="计算方式" show-overflow-tooltip>
                                        <template slot-scope="scope">
                                            {{
                                                scope.row.CalcType == 1
                                                ? '四舍五入'
                                                : scope.row.CalcType == 2
                                                    ? '向上取整'
                                                    : scope.row.CalcType == 3
                                                        ? '向下取整'
                                                        : '保留小数点'
                                            }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column min-width="160px" prop="CreateTime" label="创建时间"
                                        show-overflow-tooltip></el-table-column>
                                    <el-table-column min-width="120px" prop="Updator" label="更新人"
                                        show-overflow-tooltip></el-table-column>
                                    <el-table-column min-width="160" prop="UpdateTime" label="更新时间"
                                        show-overflow-tooltip></el-table-column>
                                    <el-table-column fixed="right" label="操作" :autoWidth="true">
                                        <template slot-scope="scope">
                                            <div class="ops-ctn">
                                                <el-button type="text" size="mini"
                                                    @click="showLevelInfoes(scope.row.LevelId)" v-if="permission.edit">{{
                                                        permission.edit
                                                    }}</el-button>
                                                <el-button type="text" size="mini" style="color: red"
                                                    @click="delLevel(scope.row.LevelId)" v-if="permission.del">{{
                                                        permission.del
                                                    }}</el-button>
                                            </div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                        <div v-else-if="isShowPerfSet">
                            <div class="search-ctn">
                                <div class="search-ctn-left">
                                    <el-button size="small" icon="el-icon-plus" class="search-btn btn-primary"
                                        v-if="permission.add" @click="showPerfInfoes()">新增商品绩效属性</el-button>
                                    <el-button size="small" icon="el-icon-setting" class="search-btn" type="primary"
                                        v-if="permission.quickSort" @click="quickPerfSort">{{
                                            permission.quickSort
                                        }}</el-button>
                                </div>
                            </div>
                            <div class="table-ctn">
                                <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tablePerfData" border
                                    style="width: 100%" height="680px">
                                    <el-table-column min-width="150px" prop="LevelName" label="绩效属性名称"
                                        show-overflow-tooltip> </el-table-column>
                                    <el-table-column min-width="100px" prop="EarnPoint" label="绩效金额"
                                        show-overflow-tooltip></el-table-column>
                                    <el-table-column min-width="100px" prop="LevelNum" label="级别数序"
                                        show-overflow-tooltip></el-table-column>
                                    <el-table-column min-width="160px" prop="CreateTime" label="创建时间"
                                        show-overflow-tooltip></el-table-column>
                                    <el-table-column min-width="120px" prop="Updator" label="更新人"
                                        show-overflow-tooltip></el-table-column>
                                    <el-table-column min-width="160" prop="UpdateTime" label="更新时间"
                                        show-overflow-tooltip></el-table-column>
                                    <el-table-column fixed="right" label="操作" :autoWidth="true">
                                        <template slot-scope="scope">
                                            <div class="ops-ctn">
                                                <el-button type="text" size="mini"
                                                    @click="showPerfInfoes(scope.row.LevelId)" v-if="permission.edit">{{
                                                        permission.edit
                                                    }}</el-button>
                                                <el-button type="text" size="mini" style="color: red"
                                                    @click="delPerf(scope.row.LevelId)" v-if="permission.del">{{
                                                        permission.del
                                                    }}</el-button>
                                            </div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                        <div v-else-if="isShowUniqueSet">
                            <div class="service-main">
                                <div class="serves-name">商品唯一性的判断依据： <el-button size="mini" type="warning"
                                        @click="saveUniqueSet()">
                                        保存
                                    </el-button></div>
                                <div class="service-item">
                                    <div class="serves-content" :key="item.AttrName" v-for="item in uniqueSetList">
                                        <el-checkbox border v-model="item.IsSpecial" :checked="item.IsSpecial" :disabled="item.AttrName == '汽配编码'">{{
                                            item.AttrName
                                        }}</el-checkbox>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="attr-content">
                            <div class="search-ctn" style="padding-bottom: 10px">
                                <div class="search-ctn-left">
                                    <el-button class="btn-primary" icon="el-icon-plus" size="small" @click="addEditRow"
                                        v-if="permission.add">添加属性</el-button>
                                    <el-button size="small" icon="el-icon-setting" type="primary"
                                        v-if="permission.quickSort" @click="attrQuickSort">{{
                                            permission.quickSort
                                        }}</el-button>
                                </div>
                            </div>
                            <div class="table-ctn">
                                <el-table :header-cell-style="{ background: '#F2F6FC' }" style="width: 60%" height="680px"
                                    :data="attrList"><el-table-column prop="SortNum" label="序号"
                                        v-if="currCode != 'deliverytype'">
                                        <template slot-scope="scope">
                                            <span v-if="!scope.row.Editing">{{ scope.row.SortNum }}</span>
                                            <div v-else class="ops-ctn-vam">
                                                <el-input-number type="number" ref="CountRef" :min="0" :precision="0"
                                                    controls-position="right" size="small"
                                                    v-model="attrformData.SortNum"></el-input-number>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="SortNum" label="优先级" v-else>
                                        <template slot-scope="scope" slot="header">
                                            <span>
                                                优先级
                                                <el-tooltip :aa="scope" class="item" effect="dark"
                                                    content="可通过快速排序调整发货方式的优先级" placement="top-start">
                                                    <i class='el-icon-warning-outline' style="margin-left:5px;'"> </i>
                                                </el-tooltip>
                                            </span>
                                        </template>
                                        <template slot-scope="scope">
                                            <span v-if="!scope.row.Editing">{{ scope.row.SortNum }}</span>
                                            <div v-else class="ops-ctn-vam">
                                                <el-input-number type="number" ref="CountRef" :min="0" :precision="0"
                                                    controls-position="right" size="small"
                                                    v-model="attrformData.SortNum"></el-input-number>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="AttrName" :label="currName" show-overflow-tooltip>
                                        <template slot-scope="scope">
                                            <span v-if="!scope.row.Editing">{{ scope.row.AttrName }}</span>
                                            <div v-else class="ops-ctn-vam">
                                                <el-input size="small" v-model="attrformData.AttrName"></el-input>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column v-if="currCode == 'sOrderSource' && isShowPricingRange" prop="IsSpecial" label="可超定价范围" width="130px">
                                        <template slot="header">
                                            <el-tooltip effect="dark" placement="top" content="商品销售开单价格不能低于批发价，且不能高于销售价">
                                                <i class="el-icon-warning-outline" style="color: orange;"></i>
                                            </el-tooltip>
                                            可超定价范围
                                        </template>
                                        <template slot-scope="scope">
                                            <span v-if="!scope.row.Editing">{{ scope.row.IsSpecial ? '是' : '否' }}</span>
                                            <div v-else class="ops-ctn-vam">
                                                <el-checkbox @change="schange"
                                                    v-model="attrformData.IsSpecial"></el-checkbox>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column v-if="currCode == 'paytype'" prop="IsSpecial" label="挂账" width="100px">
                                        <template slot-scope="scope">
                                            <span v-if="!scope.row.Editing">{{ scope.row.IsSpecial ? '是' : '否' }}</span>
                                            <div v-else class="ops-ctn-vam">
                                                <el-checkbox @change="schange"
                                                    v-model="attrformData.IsSpecial"></el-checkbox>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column v-if="currCode == 'paytype'" prop="IsSecSpecial" label="托收/代收"
                                        width="100px">
                                        <template slot-scope="scope">
                                            <span v-if="!scope.row.Editing">{{ scope.row.IsSecSpecial ? '是' : '否' }}</span>
                                            <div v-else class="ops-ctn-vam">
                                                <el-checkbox @change="secSchange"
                                                    v-model="attrformData.IsSecSpecial"></el-checkbox>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column v-if="currCode == 'deliverytype'" prop="IsSpecial" label="是否打包"
                                        width="100px">
                                        <template slot-scope="scope">
                                            <span v-if="!scope.row.Editing">{{ scope.row.IsSpecial ? '是' : '否' }}</span>
                                            <div v-else class="ops-ctn-vam">
                                                <el-checkbox @change="schange"
                                                    v-model="attrformData.IsSpecial"></el-checkbox>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="操作">
                                        <template slot-scope="scope">
                                            <div class="ops-ctn-vam">
                                                <el-button title="编辑" size="mini"
                                                    v-if="permission.edit && !scope.row.Editing"
                                                    @click="showEditRow(scope.row, scope.$index)">
                                                    <i class="el-icon-edit-outline"></i>
                                                </el-button>
                                                <el-button size="mini" v-if="scope.row.Editing" type="primary"
                                                    @click="saveAttrData(scope.row, scope.$index)">
                                                    保存
                                                </el-button>
                                                <el-button size="mini" v-if="scope.row.Editing" type="info"
                                                    @click="cancleEditRow(scope.row, scope.$index)">
                                                    取消
                                                </el-button>
                                                <el-button title="删除" size="mini" type="danger"
                                                    v-if="permission.del && !scope.row.Editing"
                                                    @click="delAttr(scope.row, scope.$index)">
                                                    <i class="el-icon-delete"></i>
                                                </el-button>
                                            </div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </el-card>
                </el-main>
            </el-container>
        </el-container>
        <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="dialogLevelVisible" width="600px">
            <div class="dialog-content" v-if="dialogLevelVisible">
                <CusPriceLevelEdit ref="priceLevelEdit" :levelId="levelId" :count="tableDataLength"
                    @closeDialog="closeLevelDialog"></CusPriceLevelEdit>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="快速排序" :visible.sync="dialogQuickSortVisible" width="500px">
            <div class="dialog-content" v-if="dialogQuickSortVisible">
                <CusPriceLevelSort ref="priceLevelSort" :levelDatas="tableData" @closeDialog="closeQuickSortDialog">
                </CusPriceLevelSort>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="快速排序" :visible.sync="dialogAttrSortVisible" width="500px">
            <div class="dialog-content" v-if="dialogAttrSortVisible">
                <AttrSort ref="attrSort" :attrDatas="attrList" :attrCode="currCode" @closeDialog="closeAttrSortDialog">
                </AttrSort>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="dialogPerfVisible" width="600px">
            <div class="dialog-content" v-if="dialogPerfVisible">
                <PerfSetEdit ref="perfSetEdit" :levelId="levelId" :count="tablePerfDataLength"
                    @closeDialog="closePerfDialog"></PerfSetEdit>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="快速排序" :visible.sync="dialogPerfSortVisible" width="500px">
            <div class="dialog-content" v-if="dialogPerfSortVisible">
                <PerfSetSort ref="perfSetSort" :levelDatas="tablePerfData" @closeDialog="closePerfSortDialog"></PerfSetSort>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import CusPriceLevelEdit from '@/components/business/msgSetting/cusPriceLevelEdit';
import CusPriceLevelSort from '@/components/business/msgSetting/cusPriceLevelSort';
import PerfSetEdit from '@/components/business/msgSetting/perfSetEdit';
import PerfSetSort from '@/components/business/msgSetting/perfSetSort';
import AttrSort from '@/components/business/msgSetting/attrSort';
export default {
    name: '',
    components: {
        breadcrumb,
        CusPriceLevelEdit,
        CusPriceLevelSort,
        AttrSort,
        PerfSetEdit,
        PerfSetSort
    },
    data() {
        return {
            isEdit: false,
            dialogPerfVisible: false,
            dialogPerfSortVisible: false,
            dialogAttrSortVisible: false,
            currName: '',
            currCode: '',
            attrTypeData: [],
            attrList: [],
            attrformData: {
                Id: '',
                AttrCode: '',
                AttrName: '',
                IsSpecial: false,
                IsSecSpecial: false,
                SortNum: 1
            },
            treeProps: {
                label: 'Name'
            },
            permission: {},
            isShrink: false, // 是否收缩状态
            currentNodeKey: '', // 当前选中的节点(移动/复制到的目标文件夹id)
            isShowPL: false,
            isShowPerfSet: false,
            levelId: '',
            title: '',
            dialogLevelVisible: false,
            dialogQuickSortVisible: false,
            tableData: [],
            tableDataLength: 0,
            tablePerfData: [],
            tablePerfDataLength: 0,
            isCheckCode: true,
            isShowUniqueSet: false,
            isShowPricingRange:false,
            uniqueSetList: [],
            compUSList: [], //用来做唯一性有无修改对比的数据
        };
    },
    watch: {
        currentNodeKey(id) {
            // Tree 内部使用了 Node 类型的对象来包装用户传入的数据，用来保存目前节点的状态。可以用 $refs 获取 Tree 实例
            if (id.toString()) {
                this.$refs['tree'].setCurrentKey(id);
            } else {
                this.$refs['tree'].setCurrentKey(null);
            }
        }
    },
    created() {
        this.permission = this.$util.getPermission('attrConfigs');
        let shrinkStu = this.$util.getLocalStorage('attrShrinkStu');
        this.isShrink = shrinkStu * 1 === 1;

        this.getConfigByCodes().then(() => {
            if (this.isCheckCode) {
                this.attrTypeData = [
                    {
                        Id: '',
                        Name: '基础属性',
                        children: [
                            { Id: 'paytype', Name: '支付方式' },
                            { Id: 'deliverytype', Name: '发货方式' },
                            { Id: 'sOrderSource', Name: '销售订单来源' },
                            { Id: 'pOrderSource', Name: '采购订单来源' },
                            { Id: 'sOrderReason', Name: '销售退货原因' },
                            { Id: 'pOrderReason', Name: '采购退货原因' },
                            { Id: 'priceLevel', Name: '价格等级设置' },
                            { Id: 'tasksType', Name: '拜访类型' },
                            { Id: 'perfSet', Name: '绩效属性设置' }, //保持在最下面就好
                            { Id: 'coprojects', Name: '合作项目' },
                        ]
                    }
                ];
            }
            else {
                this.attrTypeData = [
                    {
                        Id: '',
                        Name: '基础属性',
                        children: [
                            { Id: 'paytype', Name: '支付方式' },
                            { Id: 'deliverytype', Name: '发货方式' },
                            { Id: 'sOrderSource', Name: '销售订单来源' },
                            { Id: 'pOrderSource', Name: '采购订单来源' },
                            { Id: 'sOrderReason', Name: '销售退货原因' },
                            { Id: 'pOrderReason', Name: '采购退货原因' },
                            { Id: 'priceLevel', Name: '价格等级设置' },
                            { Id: 'tasksType', Name: '拜访类型' },
                            { Id: 'perfSet', Name: '绩效属性设置' },
                            { Id: 'uniqueSet', Name: '商品唯一性设置' },
                            { Id: 'coprojects', Name: '合作项目' },
                        ]
                    }
                ];
            }

            ///是否开启了电商平台权限开了再给平台项目
            let ecpIsOpen = this.$util.getAcrossNavNode('ctn', 1).find(x=>x.Code == "ECPlatform");
            if(ecpIsOpen){
                this.attrTypeData[0].children.push({ Id: 'ecPlatform', Name: '电商平台' })
            }
        })
        this.currName = '支付方式';
        this.currCode = 'paytype';
        this.currentNodeKey = this.currCode;
        this.getAttrData();
    },
    mounted() { },
    computed: {},
    methods: {
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['xzqpbmdwyx','sxszlyxsdj'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'xzqpbmdwyx': //是否检测编码重复
                                    this.isCheckCode = result;
                                    break;
                                case 'sxszlyxsdj': //是否显示定价范围
                                    this.isShowPricingRange = result;
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        // 改变收缩状态
        changeShrink() {
            this.isShrink = !this.isShrink;
            let value = !this.isShrink ? 0 : 1;
            this.$util.setLocalStorage('attrShrinkStu', value);
        },
        //共三个参数，依次为：传递给 data 属性的数组中该节点所对应的对象、节点对应的 Node、节点组件本身
        handleNodeClick(data, node, VueComponent) {
            if (data && data.Id)
                if (data.Id == 'priceLevel') {
                    this.isShowPL = true;
                    this.isShowPerfSet = false;
                    this.isShowUniqueSet = false;
                    if (this.tableData.length == 0) this.getTableData();
                } else if (data.Id == 'perfSet') {
                    this.isShowPerfSet = true;
                    this.isShowPL = false;
                    this.isShowUniqueSet = false;
                    if (this.tablePerfData.length == 0) this.getPerfTableData();
                } else if (data.Id == 'uniqueSet') {
                    this.isShowPL = false;
                    this.isShowPerfSet = false;
                    this.isShowUniqueSet = true;
                    if (this.uniqueSetList.length == 0) this.getUniqueSetData();
                } else if (data.Id == 'ecPlatform') {
                    this.isShowPL = false;
                    this.isShowPerfSet = false;
                    this.isShowUniqueSet = false;
                    if (!this.isEdit) {
                        this.currName = "平台名称";
                        this.currCode = data.Id;
                        this.currentNodeKey = data.Id;
                        this.getAttrData();
                    }   
                } else {
                    this.isShowPL = false;
                    this.isShowPerfSet = false;
                    this.isShowUniqueSet = false;
                    if (!this.isEdit) {
                        this.currName = data.Name;
                        this.currCode = data.Id;
                        this.currentNodeKey = data.Id;
                        this.getAttrData();
                    }
                }
        },
        getAttrData() {
            this.$util
                .axiosGet({
                    url: '/api/EntpInfoManagement/GetEntpAttrDatas?attrCode=' + this.currCode
                })
                .then(res => {
                    if (res.data) {
                        res.data.forEach(item => {
                            item.Editing = false;
                        });
                        this.attrList = res.data;
                    } else {
                        this.attrList = [];
                    }
                });
        },
        addEditRow() {
            if (this.isEdit) return;
            this.attrformData.Id = '';
            this.attrformData.AttrCode = this.currCode;
            this.attrformData.AttrName = '';

            if(this.currCode == 'ecPlatform'){
                this.attrformData.SortNum = this.attrList.length + 1;
            }else{
                this.attrformData.SortNum = 1;
            }
            
            this.attrformData.IsSpecial = false;
            this.attrformData.IsSecSpecial = false;
            this.attrList.push({
                Id: '',
                AttrCode: '',
                AttrName: '',
                SortNum: 1,
                IsSpecial: false,
                IsSecSpecial: false,
                Editing: true
            });
            this.isEdit = true;
        },
        showEditRow(row, index) {
            if (this.isEdit) return;
            this.attrformData.Id = row.Id;
            this.attrformData.AttrCode = row.AttrCode;
            this.attrformData.AttrName = row.AttrName;
            this.attrformData.SortNum = row.SortNum;
            this.attrformData.IsSpecial = row.AttrCode == 'paytype' || row.AttrCode == 'deliverytype' ? row.IsSpecial : false;
            this.attrformData.IsSecSpecial = row.AttrCode == 'paytype' || row.AttrCode == 'deliverytype' ? row.IsSecSpecial : false;
            this.isEdit = true;
            row.Editing = true;
        },
        cancleEditRow(row, index) {
            if (row.Id) row.Editing = false;
            else {
                this.attrList.splice(index, 1);
            }
            this.isEdit = false;
        },
        saveAttrData(row, index) {
            let that = this;
            that.attrformData.AttrCode = that.currCode;
            this.$util
                .axiosPost({
                    url: '/api/EntpInfoManagement/EditEntpAttrData',
                    data: that.attrformData
                })
                .then(res => {
                    if (res.errcode == 0) {
                        that.$message({
                            type: 'success',
                            message: '保存成功'
                        });
                        row.Id = res.data;
                        row.AttrCode = that.attrformData.AttrCode;
                        row.AttrName = that.attrformData.AttrName;
                        row.SortNum = that.attrformData.SortNum;
                        row.IsSpecial = that.attrformData.IsSpecial;
                        row.IsSecSpecial = that.attrformData.IsSecSpecial;
                        that.attrList.sort(function (a, b) {
                            return a.SortNum - b.SortNum;
                        });

                        row.Editing = false;
                        that.isEdit = false;
                    }
                })
                .catch(() => { });
        },
        delAttr(row, index) {
            if (this.isEdit) return;
            this.$confirm('一经删除无法恢复,是否确认删除？', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            })
                .then(() => {
                    this.$util
                        .axiosPost({
                            url: '/api/EntpInfoManagement/DelEntpAttrData?id=' + row.Id
                        })
                        .then(res => {
                            if (res.errcode == 0) {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功'
                                });
                            }
                            this.attrList.splice(index, 1);
                        })
                        .catch(() => { });
                })
                .catch(action => { });
        },
        schange(checked) {
            if (checked) {
                if (this.attrformData.IsSecSpecial) {
                    this.attrformData.IsSecSpecial = false;
                }
            }
        },
        secSchange(checked) {
            if (checked) {
                if (this.attrformData.IsSpecial) {
                    this.attrformData.IsSpecial = false;
                }
            }
        },
        // 获取价格等级数据
        getTableData() {
            let that = this;
            that.loading = true;
            that.$util
                .axiosGet({
                    url: '/api/EntpInfoManagement/GetCusPriceLevelList',
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    that.tableData = data;
                    that.tableDataLength = res.count;
                })
                .finally(() => {
                    that.loading = false;
                });
        },
        showLevelInfoes(levelId) {
            if (levelId) {
                this.levelId = levelId;
                this.title = '编辑商品价格等级';
            } else {
                this.levelId = '';
                this.title = '添加商品价格等级';
            }
            this.dialogLevelVisible = true;
        },
        closeLevelDialog(isEdit) {
            if (isEdit) {
                this.getTableData();
            }
            this.dialogLevelVisible = false;
        },
        delLevel(levelId) {
            let that = this;
            if (levelId) {
                that.$confirm('您确认要删除该价格等级吗？', '提示', {
                    confirmButtonText: '确定继续删除',
                    cancelButtonText: '不了',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        that.loading = true;
                        that.$util
                            .axiosPost({
                                url: `/api/EntpInfoManagement/DelCusPriceLevel?plId=${levelId}`,
                                hideLoading: true
                            })
                            .then(() => {
                                that.$util.successMsg('成功删除价格等级');
                                that.getTableData();
                            })
                            .finally(() => {
                                that.loading = false;
                            });
                    })
                    .catch(() => { });
            } else that.$util.warningMsg('请选择要删除的价格等级');
        },
        quickSort() {
            this.dialogQuickSortVisible = true;
        },
        closeQuickSortDialog(isEdit) {
            if (isEdit) {
                this.getTableData();
            }
            this.dialogQuickSortVisible = false;
        },
        attrQuickSort() {
            this.dialogAttrSortVisible = true;
        },
        closeAttrSortDialog(isEdit) {
            if (isEdit) {
                this.getAttrData();
            }
            this.dialogAttrSortVisible = false;
        },
        quickPerfSort() {
            this.dialogPerfSortVisible = true;
        },
        closePerfSortDialog(isEdit) {
            if (isEdit) {
                this.getPerfTableData();
            }
            this.dialogPerfSortVisible = false;
        },
        getPerfTableData() {
            let that = this;
            that.loading = true;
            that.$util
                .axiosGet({
                    url: '/api/EntpInfoManagement/GetPerfSetList',
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    that.tablePerfData = data;
                    that.tablePerfDataLength = res.count;
                })
                .finally(() => {
                    that.loading = false;
                });
        },
        showPerfInfoes(levelId) {
            if (levelId) {
                this.levelId = levelId;
                this.title = '编辑商品绩效属性设置';
            } else {
                this.levelId = '';
                this.title = '添加商品绩效属性设置';
            }
            this.dialogPerfVisible = true;
        },
        closePerfDialog(isEdit) {
            if (isEdit) {
                this.getPerfTableData();
            }
            this.dialogPerfVisible = false;
        },
        delPerf(levelId) {
            let that = this;
            if (levelId) {
                that.$confirm('您确认要删除该商品绩效属性设置吗？', '提示', {
                    confirmButtonText: '确定继续删除',
                    cancelButtonText: '不了',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        that.loading = true;
                        that.$util
                            .axiosPost({
                                url: `/api/EntpInfoManagement/DelPerfSet?plId=${levelId}`,
                                hideLoading: true
                            })
                            .then(() => {
                                that.$util.successMsg('成功删除商品绩效属性设置');
                                that.getPerfTableData();
                            })
                            .finally(() => {
                                that.loading = false;
                            });
                    })
                    .catch(() => { });
            } else that.$util.warningMsg('请选择要删除的商品绩效属性设置');
        },
        getUniqueSetData() {
            let that = this;
            that.loading = true;
            that.$util
                .axiosGet({
                    url: '/api/EntpInfoManagement/GetEntpUniqueSetDatas'
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    that.uniqueSetList = data;
                    that.compUSList = JSON.parse(JSON.stringify(data));
                })
                .finally(() => {
                    that.loading = false;
                });
        },
        saveUniqueSet() {
            let that = this;
            let isUpdate = false;
            let isHaveSet = false;
            let setData = [];
            that.uniqueSetList.forEach(ele => {
                let set = that.compUSList.find(i => i.AttrName === ele.AttrName);
                if (set) {
                    if (set.IsSpecial != ele.IsSpecial) {
                        isUpdate = true;
                    }
                }
                if (ele.IsSpecial)
                    isHaveSet = true;
                let newSet = {
                    IsSet: ele.IsSpecial,
                    AttrCode: ele.AttrCode,
                    AttrName: ele.AttrName,
                    SortNum: ele.SortNum
                }
                setData.push(newSet);
            });

            if (!isHaveSet) {
                that.$util.warningMsg("必须设置商品唯一判断条件");
                return;
            }

            if (!isUpdate) {
                that.$util.warningMsg("您未更新相关的配置");
                return;
            }
            that.$confirm('您确认要修改唯一性设置吗？', '提示', {
                confirmButtonText: '确定修改',
                cancelButtonText: '不了',
                type: 'warning',
                center: false
            })
                .then(() => {
                    that.loading = true;
                    that.$util
                        .axiosPost({
                            url: `/api/EntpInfoManagement/UpdateUniqueSetDatas`,
                            data: setData,
                            hideLoading: true
                        })
                        .then(() => {
                            that.$util.successMsg('成功设置商品唯一性判断条件');
                            that.compUSList = JSON.parse(JSON.stringify(that.uniqueSetList));
                        })
                        .finally(() => {
                            that.loading = false;
                        });
                })
                .catch(() => { });
        }
    }
};
</script>
<style lang="less">
.el-tree-node__content {
    height: 32px;
}

.business-content-main .el-card::-webkit-scrollbar {
    display: none;
}

.attr-content .table-ctn .el-table .el-table__body .el-table__row .cell button {
    padding: 3px 7px 3px 7px !important;
}
</style>
<style lang="less" scoped>
.treeClass {
    width: auto;
    height: auto;
    border: cadetblue 1px solid;
    padding: 20px;
}

.shrink-out-view {
    background-color: rgba(0, 0, 0, 0.075);
    display: flex;
    align-items: center;
    cursor: pointer;
}

.shrink-in-view {
    width: 100%;
    height: 30px;
    background-color: #409eff;
    border-radius: 7px;
    text-align: center;
    display: flex;
    align-items: center;
    color: #fff;
}

.shrink-in-view .active {
    transform: rotate(-180deg);
}

.ops-ctn-vam {
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
}

.service-main {
    max-width: 800px;
    margin: 0 auto;
    padding-top: 50px;
    font-size: @font-md;
}

.service-item {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: flex-start;
    margin-top: 15px;
    margin-left: 180px;
}

.serves-content {
    margin: 10px;
}
</style>
